var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":_vm.to}},[_c('div',{staticClass:"btn-overview"},[_c('i',{class:'icon-report far fa-' + _vm.icon}),_c('h4',{staticClass:"title-overview"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"p-overview"},[_vm._v(_vm._s(_vm.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }